<div class="iti-container" [ngClass]="{ 'even-background': !(index % 2) }">
    <div class="iti-absolute" [ngClass]="{ 'even-background': !(index % 2) }">
        <fa-icon [icon]="iconOfiti"></fa-icon>
    </div>
    <div class="iti-border">
        <a
            (click)="goToProgram(itineraryItem?.programid)"
            class="iti-program-name program-link"
        >
            {{ itineraryItem?.programname }}
        </a>
        <p>
            <small class="iti-small">
                {{ itineraryItem?.location }} | {{ itineraryItem?.type }}
            </small>
        </p>
        <p class="iti-text">
            {{ itineraryItem?.saved_selected_date?.session }}
        </p>
        <p class="iti-text">${{ itineraryItem?.price }} USD</p>
        <ion-row>
            <ion-col size="5" class="ion-no-padding">
                <ion-button
                    fill="outline"
                    class="iti-dates-btn"
                    color="secondary"
                    (click)="updateDate()"
                >
                    Change Dates
                </ion-button>
                <ion-select
                    placeholder="Change Dates"
                    interface="alert"
                    [interfaceOptions]="customAlertOptions"
                    [(ngModel)]="savedItem.display"
                    class="sneaky-change-dates"
                    (ionChange)="changeDates($event)"
                >
                    <ion-select-option *ngFor="let time of rows" [value]="time">
                        {{ time?.display }}
                    </ion-select-option>
                </ion-select>
            </ion-col>
            <ion-col size="4">
                <!-- <div class="next-container">
                    <span class="iti-label">Next Step:</span>
                    <ion-text
                        (click)="action()"
                        fill="clear"
                        color="secondary"
                        class="iti-next-btn"
                    >
                        <span>
                            Complete Requirements
                        </span>
                    </ion-text>
                </div> -->
            </ion-col>
            <ion-col size="3" class="iti-last-col ion-text-left">
                <ion-button
                    (click)="removeFromItinerary()"
                    fill="clear"
                    shape="round"
                    class="iti-remove"
                >
                    Remove
                </ion-button>
            </ion-col>
        </ion-row>
    </div>
</div>
